import {Node, XYPosition} from '@xyflow/react';
import {v4 as uuidv4} from 'uuid';

import {MyNodeTypes} from '.';

export function newNode(params: {
  type: MyNodeTypes;
  position: XYPosition;
  data: any;
  [key: string]: any;
}): Node {
  return {
    id: params?.data?.uuid || uuidv4(),
    ...params,
  };
}
